// DISTILL brand mark — modern <picture> with WebP-preferred + PNG fallback.
// Ships an 8KB WebP for 96%+ of browsers, gracefully falls back to a 37KB PNG.
// Keeps API surface (`size`, `className`) unchanged for existing callsites.

export default function DistillMark({ size = 32, className = "" }) {
  return (
    <picture>
      <source srcSet="/brand/distill-mark.webp" type="image/webp" />
      <img
        src="/brand/distill-mark.png"
        srcSet="/brand/distill-mark.png 1x, /brand/distill-mark@2x.png 2x"
        alt="DISTILL"
        width={size}
        height={size}
        draggable="false"
        loading="eager"
        decoding="async"
        className={`rounded-lg object-cover select-none ${className}`}
        style={{ width: size, height: size }}
      />
    </picture>
  );
}
